// API抽象化レイヤー
// TauriモードとWebモードの両方で動作するように設計

import { invoke } from '@tauri-apps/api/core';
import type { ApiResponse } from '../types/api';
import * as httpApi from './http-api';

// ============================================================================
// 環境検出
// ============================================================================

/**
 * Tauri環境かどうかを判定
 */
function isTauriEnvironment(): boolean {
  return typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window;
}

/**
 * APIベースURLを取得
 */
function getApiBaseUrl(): string {
  if (isTauriEnvironment()) {
    // Tauri環境ではinvokeを使用するため、URLは不要
    return '';
  }
  // Web環境では環境変数から取得
  // react-scriptsはビルド時にprocess.env.REACT_APP_*を検索してコードに埋め込む
  // ブラウザの実行時にはprocess.envは存在しないため、ビルド時に埋め込まれた値を使用
  // @ts-ignore - react-scriptsがビルド時にprocess.envを置き換える
  const envUrl = process.env.REACT_APP_API_BASE_URL;
  
  if (envUrl && envUrl !== 'undefined' && envUrl.trim() !== '') {
    console.log('[API Client] Using REACT_APP_API_BASE_URL:', envUrl);
    return envUrl;
  }
  
  // グローバル変数（ビルド時に注入）
  if (typeof window !== 'undefined' && (window as any).__API_BASE_URL__) {
    const url = (window as any).__API_BASE_URL__;
    console.log('[API Client] Using __API_BASE_URL__:', url);
    return url;
  }
  
  console.warn('[API Client] API_BASE_URL is not set. Using default: http://localhost:3000');
  console.warn('[API Client] Please set REACT_APP_API_BASE_URL environment variable in Cloudflare Pages settings');
  console.warn('[API Client] Current process.env.REACT_APP_API_BASE_URL:', envUrl);
  return 'http://localhost:3000';
}

// ============================================================================
// API呼び出しの抽象化
// ============================================================================

/**
 * API呼び出しの共通関数
 * Tauri環境ではinvokeを使用し、Web環境ではHTTP APIを使用
 */
async function callApi<T>(
  command: string,
  args?: Record<string, any>
): Promise<ApiResponse<T>> {
  if (isTauriEnvironment()) {
    // Tauri環境: invokeを使用
    try {
      const result = await invoke<ApiResponse<T>>(command, args);
      return result;
    } catch (error) {
      console.error(`[Tauri API] ${command} error:`, error);
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Unknown error'
      };
    }
  } else {
    // Web環境: HTTP APIを使用
    return httpApi.callHttpApi<T>(command, args);
  }
}

// ============================================================================
// エクスポート
// ============================================================================

export { callApi, isTauriEnvironment, getApiBaseUrl };

